import {observable, action} from 'mobx';
import objectAssign from 'object-assign';
import {WeaTools, WeaIntro, WeaLocaleProvider} from 'ecCom';
const {Intro} = WeaIntro;
// window.portal_intro = Intro();
import * as THEME_API from '../apis/theme';

const getLabel = WeaLocaleProvider.getLabel;

export default class IntroStore {
    @observable intro_step = {
        intro1: false,
        intro3: false,
        intro4: false,
        intro5: false,
        intro6: false,
    };

    @action
    onIntroStepChange(intro_step) {
        this.intro_step = objectAssign({}, this.intro_step, intro_step);
    }

    @action
    getPortalIntroInfo(portalThemeStore) {
        THEME_API.getPortalIntroInfo().then((result) => {
            if (result == '1') {
                const onend = () => {
                    portalThemeStore.onTopMenuVisibleChange(false);
                    portalThemeStore.onFreqUseMenuVisibleChange(false);
                    portalThemeStore.onToolbarMoreMenuVisibleChange(false);
                    portalThemeStore.onAccountVisibleChange(false);
                    this.onIntroStepChange({intro1: false, intro3: false, intro4: false, intro5: false, intro6: false});
                    THEME_API.setPortalIntroInfo({firstLoad: '0'});
                };

                this.onIntroStepChange({intro1: true});
                portalThemeStore.onTopMenuVisibleChange(true);
                portal_intro.onnextbuttonclick(step => {
                    if (step === 1) {
                        portalThemeStore.onTopMenuVisibleChange(false);
                        this.onIntroStepChange({intro1: false, intro4: true});
                        return true;
                    } else if (step === 2) {
                        portalThemeStore.onToolbarMoreMenuVisibleChange(true);
                        this.onIntroStepChange({intro4: false, intro5: true});
                        return false; // 不进行下一步，等待异步结果
                    } else if (step === 4) {
                        portalThemeStore.onToolbarMoreMenuVisibleChange(false);
                        portalThemeStore.onAccountVisibleChange(true);
                        this.onIntroStepChange({intro5: false, intro6: true});
                        return false; // 不进行下一步，等待异步结果
                    }
                });
                portal_intro.oncomplete(onend);
                portal_intro.onexit(onend);
                portal_intro.setOptions({
                    steps: [
                        {
                            element: '#portal-intro1',
                            intro: getLabel(503580, '点击这里可选择系统所有的应用模块') ,
                        },
                        {
                            element: '#portal-intro2',
                            intro: getLabel(503581, '应用模块的下级菜单均在左侧菜单显示。点击这里可显示/隐藏左侧菜单') ,
                        }, {
                            element: '#portal-intro3',
                            intro: getLabel(503582, '点这里，你可以将自己最常使用的操作菜单设置为快捷操作菜单'),
                        }, {
                            element: '#portal-intro4',
                            intro: getLabel(503584, '点击进入后台设置') ,
                        }, {
                            element: '#portal-intro5',
                            intro: getLabel(503583, '换肤、修改密码、切换账号…  所有的个性设置都在这里') ,
                        },
                    ]
                });
                portal_intro.refresh(); // 刷新队列
            }
        });
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/stores/IntroStore.js